const apiMocks = {
  ENABLED: false
};

export default apiMocks;